/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */
import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import stylesDash from '../../../styles/Dashboard.module.css';
import { ClientsTable } from "./ClientsTable";
import Loading from '../../../components/loading/Loading'
import api from "../../../service/axios/api";
import SelectOptions from "./SelectOptions";

export function RoutineClients({daysSelected}) {
    const [docs, setDocs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [itens, setItens] = useState(10);
    const [total, setTotal] = useState(0);
    // eslint-disable-next-line no-unused-vars
    const [status, setStatus] = useState({ label: '', value: '' });
    // eslint-disable-next-line no-unused-vars
    const [product, setProduct] = useState({ label: '', value: '' });
    // eslint-disable-next-line no-unused-vars
    const [statusSelected, setStatusSelected] = useState({
        label: 'Todos',
        value: '',
    });
    // eslint-disable-next-line no-unused-vars
    const [orderBy, setOrderBy] = useState({ label: 'status', value: '' });
    //   const [searchType, setSearchType] = useState();
    //   const [options, setOptions] = useState([
    //     { label: 'Pedido', value: 'orderNumber' },
    //     { label: 'Proxy', value: 'proxy' },
    //   ]);
    // eslint-disable-next-line no-unused-vars
    const [chipData, setChipData] = useState([]);

    const searchData = extra => {
        setTotal(10)
        setLoading(true)
        const cancel = new AbortController();
        api.order.reportByClient(
            extra,
            chipData,
            status.value,
            itens,
            page+1,
            orderBy.value,
            product.value,
            cancel,
            daysSelected,
        ).then((res) => {
            setTotal(res?.total)
            setDocs(res?.docs)
        })
            .catch((err) => {
                console.log(err)
            }).finally(() => setLoading(false))
    }

    useEffect(() => {
        searchData()
    }, [page, itens, daysSelected])
    return (
        <>
            <Loading open={loading} msg="Buscando..." />
            {/* <div style={{ display: 'flex', gap: 10, justifyContent: 'end' }}> */}
                <SelectOptions
                    setStatus={setStatus}
                    status={status}
                    setChipData={setChipData}
                    chipData={chipData}
                    find={searchData}
                    setOrderBy={setOrderBy}
                    product={product}
                    setProduct={setProduct}
                />
            {/* </div> */}
            <div className={stylesDash.longWidget2}>
                <Grid item xs={12} sm={12}>
                    <div style={{ marginBottom: '0.5rem' }}>
                        <li>Na coluna <span style={{ fontWeight: 'bold' }}>Contrato</span>, caso o cliente tenha mais de um contrato as informações são separadas por <span style={{ fontWeight: 'bold' }}>/ (barra)</span></li>
                        <li>Os valores nas colunas dos meses são separados por <span style={{ fontWeight: 'bold' }}>/ (barra)</span> caso o cliente tenha mais que um contrato </li>
                        <li>A sigla  <span style={{ fontWeight: 'bold' }}>QTD</span> acima dos valores indica a <span style={{ fontWeight: 'bold' }}>quantidade de pedidos criados</span> que resultaram naquele valor da coluna</li>
                        <li>Caso o cliente tenha mais de um contrato a sigla  <span style={{ fontWeight: 'bold' }}>QTD</span> será separada por <span style={{ fontWeight: 'bold' }}>/ (barra) </span></li>
                    </div>
                    <ClientsTable
                        docs={docs}
                        setDocs={setDocs}
                        page={page}
                        setPage={setPage}
                        itens={itens}
                        setItens={setItens}
                        total={total}
                        searchData={searchData}
                    />
                </Grid>
            </div>
        </>
    )
}